export default "__VITE_PUBLIC_ASSET__70e2399d__"